// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ergF","newExpiryDate":"styles_newExpiryDate__1nMLl","footer":"styles_footer__o1Rf9"};